import Store, { SelectedArticle } from '../../interfaces/Store';
import update from 'immutability-helper';

export const setSelectedArticleReducer = (state: Store, payload?: SelectedArticle): Store =>
  update(state, {
    selectedArticle: {
      $set: payload
    }
  });
